/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { imageDataCategorySchema } from './ImageDataCategorySchema'
import { imageDataCollectionNameSchema } from './ImageDataCollectionNameSchema'

export const imageDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	fileName: z.string(),
	category: imageDataCategorySchema,
	mimeType: z.string().nullable(),
	size: z.number(),
	humanReadableSize: z.string(),
	url: z.string(),
	collectionName: imageDataCollectionNameSchema,
	width: z.number(),
	height: z.number(),
	isPlaceholder: z.boolean(),
	isGenerating: z.boolean(),
	createdAt: z.iso.datetime(),
	isGenerated: z.boolean().default(false),
	startedGenerationAt: z.iso.datetime().nullable(),
	finishedGenerationAt: z.iso.datetime().nullable(),
	meta: z.record(z.string(), z.unknown()).nullable(),
})

export type ImageDataSchema = z.infer<typeof imageDataSchema>
